<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{row}">
            <template v-if="row.Status < 2">
              <template v-if="$permission.canWrite()">
                <el-button type="text" @click.stop="edit(row)">编辑</el-button>
              </template>
              <!-- <el-button v-if="$permission.canReview()" type="text" @click.stop="review(row.DocId)">
                <span>审核</span>
              </el-button> -->
            </template>
            <el-button type="text" v-else @click.stop="details(row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/finance/dealings/machiningcost/list";
import editDialog from "@/components/finance/dealings/machiningcost/editDialog";


export default {
  name: "machiningcost",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
  },

  methods: {
    // path:"/business/purchase/emptor"
    // create() {
    //   this.$refs.editDialog.openCreate()
    //   // this.$router.push({name:'editEmptor'})
    // },
    // edit() {
    //   this.$refs.editDialog.openEdit()
    //   // this.$router.push({name:'editEmptor'})
    // },
    create() {
      this.$router.push({ name: 'editMachiningCost', params: { mode: 'create' } })
    },
    edit(data) {
      this.$router.push({ name: 'editMachiningCost', params: { mode: 'edit',data} })
    },
    editById(id) {
      this.$router.push({ name: 'editMachiningCost', params: { mode: 'editById', rowId: id } })
    },
    details(data) {
      this.$router.push({ name: 'editMachiningCost', params: { mode: 'details', data } })
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.OutPocCostId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => { });
    },
  },
};
</script>